import React from "react";
import { Fallback } from "./Fallback";
import { BodyAsFormData } from "../../services/utilities/util";
import FilterContext from "../../routes/FilterContext";
import { apiCurrentCoverage } from "../../services/apis/retail/apiCurrentCoverage";

class CurrentCoverage extends React.Component {
  static contextType = FilterContext;

  state = {
    isError: 0,
    cityCount: 0,
    microMarketCount: 0,
  };

  // componentDidMount() {
  //     apiCurrentCoverage.post(BodyAsFormData(filters)).then((res) => {
  //         if (res.status !== 200) {
  //             this.setState({ isError: 1 });
  //         } else {
  //             this.setState({ cityCount: res.data.city_count, microMarketCount: res.data.micromarket_count });
  //         }
  //     });
  // }

  render() {
    if (this.state.isError === 1) {
      return (
        <div className="col-lg-4 mb-4">
          <div className="widget">
            <div className="row">
              <Fallback />
            </div>
            <p className="widgetName">Current Coverage</p>
          </div>
        </div>
      );
    }
    return (
      <div className="col-lg-4 mb-4">
        <div className="widget">
          <div className="row">
            <div className="col-lg-4 flexCenter">
              <img
                alt="Current Coverage Icon"
                src="/edge/images/current_coverage.png"
                className="imgWidth100"
              />
            </div>
            <div className="col-lg-8 text-start colorBlue">
              <h1>{this.state.cityCount} Cities</h1>
              <p>({this.state.microMarketCount} Micro-markets)</p>
            </div>
          </div>
          <p className="widgetName">Current Coverage</p>
        </div>
      </div>
    );
  }
}

export default CurrentCoverage;
